import React, { Component } from "react";
import i18n from "../utils/i18n";

class HsluHeader extends Component {
  render() {
    return (
      <div>
        <div id="fhzlogo">
          <a href="http://www.hslu.ch/">
          <img src="images/hslu-logo.svg?sc_lang=de-ch" height="80" id="logo-bitmap" alt="Startseite – Hochschule Luzern" width="220"></img>
          </a>
        </div>
        <div id="teilschule">
          <div align="right">
            <a href="https://www.hslu.ch/de-ch/musik">
              <u>zur&uuml;ck</u>
            </a>{" "}
            zur Website
            <br />Hochschule Luzern - Musik
          </div>
        </div>
        <div id="sprachauswahl">
          <div align="right">
            <a
              href="#de"
              onClick={e => {
                e.preventDefault();
                i18n.changeLanguage("de");
              }}
            >
              deutsch
            </a>
            <br />
            <a
              href="#it"
              onClick={e => {
                e.preventDefault();
                i18n.changeLanguage("it");
              }}
            >
              italiano
            </a>
            <br />
            <a
              href="#fr"
              onClick={e => {
                e.preventDefault();
                i18n.changeLanguage("fr");
              }}
            >
              français
            </a>
          </div>
        </div>
        <div id="breadcrumb">
          <div id="breadcrumbbottom">
            <strong>
              <a href="https://www.hslu.ch/de-ch/musik" title="Musik">
                Musik
              </a>
            </strong>
            <img
              width="6"
              height="1"
              src="images/spacer.gif"
              border="0"
              alt="spacer"
            />{" "}
            >
            <img
              width="6"
              height="1"
              src="images/spacer.gif"
              border="0"
              alt="spacer"
            />{" "}
            Orgeldokumentationszentrum
          </div>
        </div>
        <div id="beginlinenavigation" className="hslu-top-navi" />
        <div id="beginlinecontent" className="hslu-top-navi" />
        <div id="beginlinesidebox" className="hslu-top-navi" />
      </div>
    );
  }
}

export default HsluHeader;



// WEBPACK FOOTER //
// ./src/app-header/HsluHeader.js